import React, { useEffect } from 'react';
import { AuthProvider, useAuth } from './hooks/useAuth';
import { api } from './services/api';
import { FONT, colors } from './theme';
import LoginPage from './pages/Login';
import Dashboard from './pages/Dashboard';
import JoinPage from './pages/JoinPage';

function AppRouter() {
  const { user, loading, loginWithToken } = useAuth();

  // Parse URL: /join/:code, /add-contact?... or ?auth_code=xxx
  const path = window.location.pathname;
  const params = new URLSearchParams(window.location.search);
  const joinCode = path.startsWith('/join/') ? path.split('/join/')[1] : null;
  const isAddContact = path === '/add-contact';
  // SEC-010: Use one-time auth_code instead of raw JWT token in URL
  const authCode = params.get('auth_code');

  // Auto-login from Telegram bot link (one-time code exchange)
  useEffect(() => {
    if (authCode && !user) {
      api.exchangeCode(authCode)
        .then(data => {
          if (data.token && data.user) {
            loginWithToken(data.token, data.user);
            // Clean URL — remove auth_code from address bar
            window.history.replaceState({}, '', window.location.pathname);
          }
        })
        .catch(() => {});
    }
  }, [authCode]);

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', background: colors.gray50, display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: FONT }}>
        <div style={{ color: colors.gray400, fontSize: 15 }}>Загрузка...</div>
      </div>
    );
  }

  // Public join link — no auth needed
  if (joinCode) {
    return <JoinPage code={joinCode} />;
  }

  // Add contact via shared link — redirect to dashboard with contact data
  if (isAddContact && user) {
    const name = params.get('name') || '';
    const ext = params.get('ext') || '';
    // Clean URL and pass contact data as state
    window.history.replaceState({}, '', '/');
    return <Dashboard addContact={{ name, extension: ext }} />;
  }
  if (isAddContact && !user) {
    // Need to login first, then add contact
    return <LoginPage />;
  }

  if (!user) return <LoginPage />;

  return <Dashboard />;
}

export default function App() {
  return (
    <AuthProvider>
      <AppRouter />
    </AuthProvider>
  );
}
